// angular dependencies
import { AsyncPipe } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  computed,
  input,
  output,
  ViewEncapsulation,
} from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDivider } from '@angular/material/divider';
import { MatIconModule } from '@angular/material/icon';
import { RouterModule } from '@angular/router';

// fantaz dependencies
import {
  CasualTournamentDetails,
  EventSchedule,
} from '@fantaz/shared/data-access/models';
import { SharedPipesDateModule } from '@fantaz/shared/pipes/date';
import { CurrencyModule } from '@fantaz/shared/ui/currency';
import { PlayButtonModule } from '@fantaz/tournaments/ui/play-button';
import {
  CardDetails,
  CardDetailsActions,
  CardDetailsExpansionItem,
  CardDetailsItem,
  CardDetailsRowBody,
  CardDetailsRowDescription,
  CardDetailsRowTitle,
} from '@fantaz/ui';
import { SeatsResumePipe } from './seats-resume.pipe';

@Component({
  selector: 'fz-cash-card-details',
  standalone: true,
  imports: [
    MatDivider,
    MatButtonModule,
    MatIconModule,
    CardDetails,
    CardDetailsItem,
    CardDetailsRowTitle,
    CardDetailsRowDescription,
    CardDetailsActions,
    CardDetailsRowBody,
    RouterModule,
    PlayButtonModule,
    CurrencyModule,
    SharedPipesDateModule,
    AsyncPipe,
    SeatsResumePipe,
    CardDetailsExpansionItem,
  ],
  templateUrl: './cash-card-details.html',
  styleUrls: ['./cash-card-details.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
})
export class CashCardDetails {
  schedule = input.required<EventSchedule>();
  tournamentDetails = input.required<CasualTournamentDetails | any>();
  share = output<EventSchedule>();

  firstPlacePrize = computed(() => {
    const schedule = this.schedule();
    let prize;

    if (schedule.prizeDetails) {
      const prizeDetails = schedule.prizeDetails.find((el) => el.rank === 1);

      prize = prizeDetails?.prizeValue;
    }

    return prize;
  });

  zboReferral = computed(() => {
    const schedule = this.schedule();
    let amount;

    if (schedule.uniLevelDetails) {
      for (let i = 0; i < schedule.uniLevelDetails.length; i++) {
        if (schedule.uniLevelDetails[i].level === 1) {
          amount = schedule.uniLevelDetails[i].amountPerUser;
          break;
        }
      }
    }

    return amount;
  });

  shareScheduler() {
    this.share.emit(this.schedule());
  }
}
